export default __webpack_public_path__ + "static/media/7.1.042cdd84.jpg";